// extracted by mini-css-extract-plugin
export default {"galeria":"Galeria_galeria__RsaPu","fotografa":"Galeria_fotografa__eOmM7","subtitulo":"Galeria_subtitulo__q9JuO","foto_jogos":"Galeria_foto_jogos__BLO2n"};